import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
  shareReplay,
  startWith,
} from 'rxjs/operators';

@Injectable()
export class NavigationService {
  constructor(private router: Router) {}

  public currentRoute(): Observable<string> {
    return this.router.events.pipe(
      filter<NavigationEnd>((event) => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects),
      startWith(location.pathname),
      distinctUntilChanged(),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }

  public isRouteActive(route: string): Observable<boolean> {
    return this.currentRoute().pipe(map((current) => current.includes(route)));
  }
}
